import React, { memo } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { env } from 'env';
import { CustomIcon } from '@p81-common/ui';

import classes from './NotificationsButton.module.scss';

const NotificationsButton = ({ toggleNotificationsOpen, unreadCount }) => {
  const badgeText = unreadCount.toString();
  return (
    <IconButton
      size="small"
      onClick={toggleNotificationsOpen}
      data-testid="button-notification"
      className={cn(classes.divider, classes.notificationButton)}
    >
      <Badge
        badgeContent={unreadCount}
        classes={{
          badge: cn(
            classes.badge,
            badgeText.length === 2 && classes.badge_two,
            badgeText.length === 3 && classes.badge_three
          )
        }}
      >
        <CustomIcon
          src={`${env.REACT_APP_STATIC_ASSETS_URL}/icons/icon_alert.svg`}
        />
      </Badge>
    </IconButton>
  );
};

NotificationsButton.propTypes = {
  toggleNotificationsOpen: PropTypes.func,
  unreadCount: PropTypes.number
};

export default memo(NotificationsButton);
